import axiosInstance from "../utils/axios";
import { parseFilenameFromDisposition } from "../utils/download";

export const standMeterService = {
  getById: async (id) => {
    const { data } = await axiosInstance.get(`/stand-meter/${id}`);
    return data;
  },
  verify: async (id, body) => {
    const { data } = await axiosInstance.patch(
      `/stand-meter/${id}/verify`,
      body
    );
    return data;
  },
  reject: async (id, body) => {
    const { data } = await axiosInstance.patch(
      `/stand-meter/${id}/reject`,
      body
    );
    return data;
  },
  getAllData: async (params = {}) => {
    const { data } = await axiosInstance.get(`/stand-meter/paginate`, { params });
    return data;
  },
  export: async (params = {}) => {
    const response = await axiosInstance.get(`/stand-meter/export`, {
      params,
      responseType: 'blob'
    });
    const disposition = response.headers["content-disposition"];
    return { blob: response.data, filename: parseFilenameFromDisposition(disposition) || "stand-meter-report.xlsx" };
  },
};
